module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "user-list__user__table__tbody"
  }, _vm._l((_vm.events), function(event) {
    return _c('tr', {
      key: event.event_id,
      staticClass: "user-list__user__table__event",
      class: {
        'user-list__user__table__event--special': event.v_is_special,
        'user-list__user__table__event--zeroed': event.zero
      }
    }, [_c('td', [_vm._v(_vm._s(event.v_start_and_endtime) + " | "), (event.v_is_special) ? _c('span', {
      staticClass: "d-tag"
    }, [_vm._v(_vm._s(event.title))]) : _c('b', [_vm._v(_vm._s(event.title))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.v_calendar_name))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "d-tag"
    }, [_vm._v(_vm._s(event.v_event_type_name))])]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(event.v_substitute_for_name) + "\n    "), (event.v_substitute_for_employments.length > 0) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return event.v_substitute_for_employments.length > 1; }
        }),
        expression: "{\n                          arrow: true,\n                          animateFill: false,\n                          animation : 'shift-away',\n                          zIndex: '999999992',\n                          boundary: 'window',\n                          onShow: () => event.v_substitute_for_employments.length > 1\n                        }"
      }],
      staticClass: "d-tag",
      attrs: {
        "content": event.v_substitute_for_employments
      }
    }, [_vm._v("\n                    " + _vm._s(event.v_substitute_for_employments[0]) + "\n                    "), (event.v_substitute_for_employments.length > 1) ? [_vm._v("m.fl.")] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "td-employment"
    }, [_c('div', {
      staticClass: "td-employment__value"
    }, [(_vm.userDay.state === 'draft') ? [(_vm.user.v_user_active_employments.length < 1) ? _c('p', {
      staticClass: "text-explainer"
    }, [_vm._v("Ingen ansættelser")]) : _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (event.employment_id),
        expression: "event.employment_id",
        modifiers: {
          "number": true
        }
      }, {
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return !!event.v_employment_details_tip; }
        }),
        expression: "{\n                  arrow: true,\n                  animateFill: false,\n                  animation: 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window',\n                  onShow: () => !!event.v_employment_details_tip\n                }"
      }],
      staticClass: "no-print",
      attrs: {
        "content": event.v_employment_details_tip
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return _vm._n(val)
          });
          _vm.$set(event, "employment_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updatePropOnLesson('employment_id', _vm.user, _vm.userDay, event, $event.target.value)
        }]
      }
    }, _vm._l((_vm.user.v_user_active_employments), function(userEmployment) {
      return _c('option', {
        key: userEmployment.id,
        domProps: {
          "value": Number(userEmployment.id)
        }
      }, [_vm._v("\n            " + _vm._s(userEmployment.title) + "\n          ")])
    }), 0), _vm._v(" "), _c('span', {
      staticClass: "only-print",
      class: {
        'italic': event.v_employment_id_title === 'Ingen valgt'
      }
    }, [_vm._v("\n          " + _vm._s(event.v_employment_id_title) + "\n        ")])] : _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return !!event.v_employment_details_tip; }
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation: 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !!event.v_employment_details_tip\n            }"
      }],
      class: {
        'd-tag': event.v_employment_id_title && event.v_employment_id_title !== 'Ingen valgt'
      },
      attrs: {
        "content": event.v_employment_details_tip
      }
    }, [_vm._v(_vm._s(event.v_employment_id_title) + "\n      ")]), _vm._v(" "), (event.v_employment_source_tip) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n          arrow: true,\n          animateFill: false,\n          animation: 'shift-away',\n          zIndex: '999999992',\n          boundary: 'window'\n        }"
      }],
      staticClass: "td-employment__help no-print",
      attrs: {
        "content": event.v_employment_source_tip
      }
    }, [_c('span', {
      staticClass: "icon-question3"
    })]) : _vm._e()], 2)]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (event.salary_code_id),
        expression: "event.salary_code_id",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "do-select",
      attrs: {
        "disabled": _vm.userDay.state !== 'draft'
      },
      on: {
        "input": function($event) {
          return _vm.updatePropOnLesson('salary_code_id', _vm.user, _vm.userDay, event, $event.target.value)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return _vm._n(val)
          });
          _vm.$set(event, "salary_code_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
      return _c('option', {
        key: salaryCode.id,
        domProps: {
          "value": salaryCode.id
        }
      }, [_vm._v("\n        " + _vm._s(salaryCode.name) + "\n      ")])
    })], 2)]) : _vm._e(), _vm._v(" "), (_vm.costCenters.length > 0) ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (event.afv_omkostningssted),
        expression: "event.afv_omkostningssted"
      }],
      staticClass: "no-print",
      attrs: {
        "disabled": _vm.userDay.state !== 'draft'
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(event, "afv_omkostningssted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updatePropOnLesson('afv_omkostningssted', _vm.user, _vm.userDay, event, event.afv_omkostningssted)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }), _vm._v(" "), _vm._l((_vm.costCenters), function(costCenter) {
      return _c('option', {
        key: costCenter.code,
        domProps: {
          "value": costCenter.code
        }
      }, [_vm._v("\n        " + _vm._s(costCenter.title) + "\n      ")])
    })], 2)]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(event.minutes) + " min.\n  ")]), _vm._v(" "), _c('td', {
      staticClass: "td-zero-toggle no-print"
    }, [(_vm.userDay.state === 'draft') ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n        arrow: true,\n        animateFill: false,\n        animation: 'shift-away',\n        zIndex: '999999992',\n        boundary: 'window'\n      }"
      }],
      staticClass: "do-zero-bttn",
      class: {
        'do-zero-bttn--active': event.zero
      },
      attrs: {
        "content": event.zero ? 'Gendan linje' : 'Nulstil linje'
      },
      on: {
        "click": function($event) {
          return _vm.updatePropOnLesson('zero', _vm.user, _vm.userDay, event, !event.zero)
        }
      }
    }, [(!event.zero) ? _c('span', {
      staticClass: "icon-bin"
    }) : _c('svg', {
      staticClass: "do-zero-bttn__undo-icon",
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "1 4 1 10 7 10"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
      }
    })])]) : _vm._e()])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57b76e06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySubsPerfUserDay.vue
// module id = 1933
// module chunks = 1